import React from 'react';
import Skeleton from '../Skeleton';
import './DashboardSkeleton.css';

const DashboardSkeleton = () => {
  return (
    <div className="dashboard-skeleton-wrapper">
      {/* Page Header - Exact match with AdminDashboard */}
      <div className="page-header" style={{ marginBottom: '32px' }}>
        <div>
          <Skeleton variant="text" width="140px" height={32} style={{ marginBottom: '8px' }} />
          <Skeleton variant="text" width="320px" height={18} />
        </div>
        <Skeleton variant="button" width="180px" height={40} style={{ borderRadius: '8px' }} />
      </div>

      {/* Stats Grid - Exact match with dashboard-grid */}
      <div className="dashboard-grid" style={{ marginBottom: '32px' }}>
        {/* Card 1 - Work Documents (Dark with arrow) */}
        <div className="dashboard-card dark skeleton-card">
          <div className="card-header">
            <Skeleton variant="text" width="130px" height={14} style={{ backgroundColor: 'rgba(255,255,255,0.25)' }} />
            <Skeleton variant="text" width="20px" height={20} style={{ backgroundColor: 'rgba(255,255,255,0.25)' }} />
          </div>
          <Skeleton variant="text" width="50px" height={40} style={{ marginTop: '16px', marginBottom: '8px', backgroundColor: 'rgba(255,255,255,0.35)' }} />
          <Skeleton variant="text" width="90px" height={13} style={{ backgroundColor: 'rgba(255,255,255,0.2)' }} />
        </div>

        {/* Card 2 - Today's Submissions (with CircularProgress) */}
        <div className="dashboard-card skeleton-card">
          <div className="card-header">
            <Skeleton variant="text" width="145px" height={14} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', marginBottom: '8px' }}>
            <Skeleton variant="circle" size={120} />
          </div>
          <Skeleton variant="text" width="120px" height={13} style={{ margin: '0 auto' }} />
        </div>

        {/* Card 3 - This Week (with trend) */}
        <div className="dashboard-card skeleton-card">
          <div className="card-header">
            <Skeleton variant="text" width="80px" height={14} />
          </div>
          <Skeleton variant="text" width="45px" height={40} style={{ marginTop: '16px', marginBottom: '8px' }} />
          <Skeleton variant="text" width="100px" height={13} style={{ marginBottom: '12px' }} />
          {/* Trend badge */}
          <div style={{
            display: 'inline-flex',
            padding: '6px 12px',
            borderRadius: '6px',
            background: 'rgba(0, 212, 170, 0.1)'
          }}>
            <Skeleton variant="text" width="140px" height={12} style={{ backgroundColor: 'rgba(0, 212, 170, 0.2)' }} />
          </div>
        </div>

        {/* Card 4 - Active Workers (with CircularProgress) */}
        <div className="dashboard-card skeleton-card">
          <div className="card-header">
            <Skeleton variant="text" width="120px" height={14} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', marginBottom: '8px' }}>
            <Skeleton variant="circle" size={100} />
          </div>
          <Skeleton variant="text" width="145px" height={13} style={{ margin: '0 auto' }} />
        </div>
      </div>

      {/* Table Section - Exact match with DataTable */}
      <div className="data-table-container">
        {/* Table Header */}
        <div className="table-header">
          <div className="table-title-section">
            <h2 className="table-title">
              <Skeleton variant="text" width="180px" height={15} />
            </h2>
          </div>
        </div>

        {/* Table Wrapper */}
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="30px" height={11} />
                </th>
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="85px" height={11} />
                </th>
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="60px" height={11} />
                </th>
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="40px" height={11} />
                </th>
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="75px" height={11} />
                </th>
                <th style={{ padding: '8px 14px' }}>
                  <Skeleton variant="text" width="50px" height={11} />
                </th>
                <th style={{ padding: '8px 14px', textAlign: 'right' }}>
                  <Skeleton variant="text" width="60px" height={11} style={{ marginLeft: 'auto' }} />
                </th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5, 6, 7].map((row) => (
                <tr key={row}>
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="25px" height={13} />
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="100px" height={13} />
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="90px" height={13} />
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="70px" height={13} />
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="text" width="150px" height={13} />
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <Skeleton variant="badge" width="40px" height={24} />
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                      <Skeleton variant="button" width="80px" height={28} />
                      <Skeleton variant="button" width="75px" height={28} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;
